// Hermes-in-chat results under an assistant message: downloadable files
// made by build_document, and the agent task card (plan → approve → live
// progress → report) from start_agent_task or /agent. Nothing runs until the
// user presses Start. Module scope — App-level inner components remount on
// every render.
import { useState } from "react";
import AgentTaskCard from "./AgentTaskCard.jsx";

const ICON = { docx: "📄", pdf: "📕", pptx: "📊", md: "📝" };
const KIND = { docx: "Word document", pdf: "PDF", pptx: "PowerPoint", md: "Markdown" };
const size = (n) => (n >= 1048576 ? (n / 1048576).toFixed(1) + " MB" : Math.max(1, Math.round((n || 0) / 1024)) + " KB");

function FileCard({ file, authToken, S, showToast }) {
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try {
      const r = await fetch(`/api/chat-files/${encodeURIComponent(file.id)}`, { headers: { Authorization: `Bearer ${authToken}` } });
      if (r.status === 404) throw new Error("This file is no longer available (files are kept for 30 days).");
      if (!r.ok) throw new Error("Download failed (HTTP " + r.status + ")");
      const url = URL.createObjectURL(await r.blob());
      const a = document.createElement("a");
      a.href = url; a.download = file.filename || "document"; document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 30_000);
    } catch (e) { showToast && showToast(e.message); }
    setBusy(false);
  };
  return (
    <div className="cf-chat-file" style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 12px", borderRadius: 12, border: `1px solid ${S.border2}`, background: S.cardBg, maxWidth: 440 }}>
      <div style={{ fontSize: 26, lineHeight: 1 }}>{ICON[file.format] || "📎"}</div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: S.text, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{file.filename}</div>
        <div style={{ fontSize: 11, color: S.text3 }}>{KIND[file.format] || "File"} · {size(file.bytes)}{file.branded ? " · Company branding" : ""}</div>
      </div>
      <button onClick={download} disabled={busy}
        style={{ padding: "7px 14px", borderRadius: 9, border: "none", background: S.accent, color: "#fff", fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", flexShrink: 0, opacity: busy ? 0.6 : 1 }}>
        {busy ? "…" : "Download"}
      </button>
    </div>
  );
}

export default function ChatArtifacts({ msg, authToken, S, showToast, onTaskUpdate, onOpenTask }) {
  const files = Array.isArray(msg.chatFiles) ? msg.chatFiles : [];
  if (!files.length && !msg.agentTask) return null;
  return (
    <div className="cf-chat-artifacts" style={{ display: "flex", flexDirection: "column", gap: 8, margin: "8px 0 4px" }}>
      {files.map((f) => <FileCard key={f.id} file={f} authToken={authToken} S={S} showToast={showToast} />)}
      {msg.agentTask && <AgentTaskCard task={msg.agentTask} authToken={authToken} S={S} showToast={showToast} onUpdate={(patch) => onTaskUpdate && onTaskUpdate(msg.id, patch)} onOpen={onOpenTask} />}
    </div>
  );
}
